import { get, post, put, del } from '@/api/request'

// ========== 文件夹 ==========

export function getFolderTree() {
  return get('/assets/folders')
}

export function createFolder(data) {
  return post('/assets/folders', data)
}

export function updateFolder(id, data) {
  return put(`/assets/folders/${id}`, data)
}

export function moveFolder(id, data) {
  return post(`/assets/folders/${id}/move`, data)
}

export function deleteFolder(id) {
  return del(`/assets/folders/${id}`)
}

export function updateFolderAcl(id, data) {
  return put(`/assets/folders/${id}/acl`, data)
}

// ========== 标签 ==========

export function getTagList() {
  return get('/assets/tags')
}

export function createTag(data) {
  return post('/assets/tags', data)
}

export function updateTag(id, data) {
  return put(`/assets/tags/${id}`, data)
}

export function deleteTag(id) {
  return del(`/assets/tags/${id}`)
}

// ========== 素材 ==========

export function getAssetPage(data) {
  return post('/assets/page', data)
}

export function getAssetDetail(id) {
  return get(`/assets/${id}`)
}

export function createTextAsset(data) {
  return post('/assets/text', data)
}

export function updateAsset(id, data) {
  return put(`/assets/${id}`, data)
}

export function moveAsset(id, data) {
  return post(`/assets/${id}/move`, data)
}

export function updateAssetTags(id, data) {
  return put(`/assets/${id}/tags`, data)
}

export function deleteAsset(id) {
  return del(`/assets/${id}`)
}

// ========== 上传与版本 ==========

export function createUploadSession(data) {
  return post('/assets/uploads', data)
}

export function confirmUploadSession(sessionId, data) {
  return post(`/assets/uploads/${sessionId}/confirm`, data)
}

export function cancelUploadSession(sessionId) {
  return post(`/assets/uploads/${sessionId}/cancel`)
}

export function getVersionList(assetId) {
  return get(`/assets/${assetId}/versions`)
}

export function createTextVersion(assetId, data) {
  return post(`/assets/${assetId}/versions/text`, data)
}

export function restoreVersion(assetId, versionId, data) {
  return post(`/assets/${assetId}/versions/${versionId}/restore`, data)
}

export function previewAsset(id) {
  return get(`/assets/${id}/preview`)
}

export function downloadAsset(id) {
  return get(`/assets/${id}/download`)
}
